import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import {
  Http,
  RequestOptions,
  Headers,
  RequestOptionsArgs
} from "@angular/http";
import { Storage } from "@ionic/storage";
import { ConfigurationService } from "ionic-configuration-service";

/*
  Generated class for the WaybillOrderServiceProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class WarehouseServiceProvider {
  public data: any;

  public token: any;

  constructor(
    private configurationService: ConfigurationService,
    public http: Http,
    private storage: Storage
  ) {}

  load_dashboard_deta() {
    return new Promise(resolve => {
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      let options = new RequestOptions({ headers: headers });

      this.http
        .get(
          this.configurationService.getValue<string>("CLIENTPORTAL_ENDPOINT") +
            "stats/get_driver_manager_dashboard_data",
          options
        )
        .map(res => res.json())
        .subscribe(data => {
          resolve(data);
        });
    });
  }

  get_parcel_detail(awb_no) {
    return new Promise(resolve => {
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append(
        "Authorization",
        "Bearer eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiIyMDAxIiwiaWF0IjoxNDk4ODA4MDEyLCJzdWIiOiJ7XCJlY29tbWVyY2VJZFwiOjF9In0.9vhoWgksxxD0Fetr9SH0qdipe4ezVOweS-kqHZ1NIx0"
      );

      let options = new RequestOptions({ headers: headers });

      this.http
        .get(
          this.configurationService.getValue<string>("API_ENDPOINT") +
            "shipments/" +
            awb_no,
          options
        )
        .map(res => res.json())
        .subscribe(data => {
          resolve(data);
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/wh/warehouse-service.ts